// extracted by mini-css-extract-plugin
module.exports = {"LogoWall":"LogoWall_LogoWall__2c6ex","LogoGrid":"LogoWall_LogoGrid__pWHY7"};